export default __webpack_public_path__ + "static/media/growth-performance.47da3a77.svg";